import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Empty, Popover, Tag, Tooltip, Upload } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import { faArrowDownUpAcrossLine, faArrowRightArrowLeft, faCopy, faDownload, faEye, faMapLocationDot, faUpload, faWarning } from "@fortawesome/free-solid-svg-icons";

//STYLE
import { Container } from "./style";

//APP
import { OsItensTypes } from "../../../../../../services/Laboratorio";
import { handleUploadResult } from "../../meta";
import { useDeletePedidoLaboratorio } from "../../../../../../services/Laboratorio/DELETE";
import { destroyAlert, errorAlert, successAlert } from "../../../../../../utils/alert";
import { getPedLaboratorioStatus, putPedlaboratorioStatus } from "../../../../../../services/Laboratorio";
import { dados_status, statusBackground, statusBorder, statusColor, statusIcones, statusNomes } from "./meta";

//COMPONENTS
import Carregando from "../../../../../../Components/CustomUi/loading";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import CsvVisualizationModal from "./components/visualizarArquivoCSV";
import { Render } from "../../../../../../Components/CustomUi/render";
import { RowItem } from "../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../Components/CustomUi/table/rowTable";
import { BodyTable } from "../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../../../Components/CustomUi/table/headerTable";
import { IconeAlerta } from "./components/iconeAlerta";
import { DeleteButton } from "../../../../../../Components/CustomUi/deleteButton";
import { StatusTimeLine } from "./components/statusTimeLine";
import { FormularioOsColeta } from "./components/formulario";
import { VisualizarMapaTabela } from "./components/visualizarMapaTabela";
import { DownloadReprocessarOS } from "./components/download-reprocessar";

//PROPS
interface Props {
    lista_os: OsItensTypes[];
    refetch_data_osColeta: () => void;
    /** Primeira carga: ainda não há nada para mostrar. */
    loading: boolean;
    /** Qualquer busca, inclusive troca de página com dados já em tela. */
    buscando?: boolean;
    /** Total de registros no servidor — base da paginação. */
    total: number;
    /** Quantidade após o filtro local por talhão (0 = sem filtro ativo). */
    total_filtrado?: number;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPagination: React.Dispatch<React.SetStateAction<number>>;
}

/** Handle imperativo exposto ao pai: permite abrir a gaveta em modo "criar". */
export interface SoloHandle {
    abrirNovo: () => void;
}

export const Solo = forwardRef<SoloHandle, Props>(({
    lista_os, refetch_data_osColeta, loading, buscando, total, total_filtrado, page, setPage, setPagination
}, ref) => {

    //CONST
    const permissions = null;

    //#region STATES
    //GAVETA (cadastro/edição/cópia de OS)
    const [abrirGaveta, setAbrirGaveta] = useState<boolean>(false);
    const [update, setUpdate] = useState<number | null>(null);
    const [copiar, setCopiar] = useState<number | null>(null);
    const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false);
    const [id_item_atual, setId_item_atual] = useState<number>(null);
    const [nome_item_atual, setNome_item_atual] = useState<string>('');
    const [open_popover, setOpen_popover] = useState<number>(null);
    const [resultAnalise, setResultAnalise] = useState({
        base64: null,
        cod: null,
    })
    const [textCSV, setTextCSV] = useState([])
    const [abrirPreviewFile, setAbrirPreviewFile] = useState<boolean>(false)
    //VISUALIZAR MAPA
    const [abrirMapa, setAbrirMapa] = useState<boolean>(false)
    const [cod_mapa, setCod_mapa] = useState<number>(null)
    //STATUS (linha do tempo)
    const [numero_pedido, setNumero_pedido] = useState<number>(null)
    const [abrirStatus, setAbrirStatus] = useState<boolean>(false)
    const [dataStatusOs, setDataStatusOs] = useState<any[]>([])
    const [status_selecionada, setStatus_selecionada] = useState<string>('')
    const [status_selecionada_id, setStatus_selecionada_id] = useState<number>(null)
    const [loading_status, setLoading_status] = useState<boolean>(false)

    //#region API
    const { mutate_excluir_os, carregando_excluir_os } = useDeletePedidoLaboratorio()

    /** Nome de exibição do status. Lê de `statusNomes` (dicionário completo) e
     *  não de `dados_status` (só as opções selecionáveis) — era essa confusão
     *  que deixava os status 6/7/8 com a tag em branco. */
    function verificarStatusNome(cod: number) {
        const nome = statusNomes[cod]
        return nome === 'ENVIADO PARA ANÁLISE' ? 'ENVIADO' : nome
    }

    const dumpRequest = (options) => {
        const { onSuccess } = options

        setTimeout(() => {
            onSuccess('done')
        }, 500)
    }
    async function abrirModal(cod: number) {
        setLoading_status(true)
        setNumero_pedido(cod)
        setAbrirStatus(true)
        // loadingAlert({ msg: 'Carregando pedidos...', id: 'pedido' })
        const response = await getPedLaboratorioStatus(cod)
        const dados = response.data.itens
        setDataStatusOs([...dados].reverse())
        destroyAlert('pedido')
        setLoading_status(false)
    }

    const alterarStatus = async () => {
        setLoading_status(true)
        if (status_selecionada_id) {
            const listaStatus = (dados_status ?? []).find((data) => data.cod === status_selecionada_id)
            const response = await putPedlaboratorioStatus(numero_pedido, listaStatus.cod)

            if (response.status === 200) {
                successAlert(`Status da OS alterado para ${listaStatus.nome}`)
                setLoading_status(false)
                refetch_data_osColeta()
                setAbrirStatus(false)
            } else {
                errorAlert(`ERROR ${response.status}`)
                setLoading_status(false)
            }
        } else {
            errorAlert('Selecione o status para ser alterado')
            setLoading_status(false)
        }
    }

    function fecharModal() {
        setNumero_pedido(null)
        setStatus_selecionada('')
        setStatus_selecionada_id(null)
        setAbrirStatus(false)
    }

    //#region GAVETA
    /** Abre a gaveta em modo criar (usado pelo botão "Novo" do módulo pai via ref). */
    function abrirNovo() {
        setUpdate(null);
        setCopiar(null);
        setAbrirGaveta(true);
    }

    function editarOs(cod: number) {
        setCopiar(null);
        setUpdate(cod);
        setAbrirGaveta(true);
    }

    function copiarOs(cod: number) {
        setUpdate(null);
        setCopiar(cod);
        setAbrirGaveta(true);
    }

    function fecharGaveta() {
        setAbrirGaveta(false);
        setUpdate(null);
        setCopiar(null);
    }

    // Expõe o atalho de abertura para o módulo pai (NovoModuloOsParaColeta).
    useImperativeHandle(ref, () => ({ abrirNovo }), []);

    function abrirVisualizarMapa(cod: number) {
        setCod_mapa(cod);
        setAbrirMapa(true);
    }

    //#region AÇÃO DE ARQUIVO
    /**
     * Retorna a ÚNICA ação de arquivo da linha, espelhando a árvore de decisão
     * da versão em produção. Os quatro ramos são mutuamente exclusivos por
     * construção — não existe estado em que dois botões apareçam juntos.
     *
     * 1. status 9 ............... popover "Baixar análise" + "Reprocessar OS"
     * 2. status 6 ou 7 .......... popover "Baixar resultado" (+ reprocessar
     *                             só quando não há arquivo processado)
     * 3. sem calcário na prop. .. aviso bloqueando o envio
     * 4. demais status .......... upload do resultado, habilitado só em 4 e 8
     */
    function acaoArquivo({
        cod, status, arquivo_processado, arquivo_processado_url, cod_cliente,
        propriedade_nome, talhao_nome, cod_calcario, cod_calcario_propriedade,
    }: {
        cod: number; status: number; arquivo_processado?: string;
        arquivo_processado_url: string; cod_cliente: number;
        propriedade_nome: string; talhao_nome: string;
        cod_calcario: number; cod_calcario_propriedade: number;
    }) {
        const inconsistente = status === 6 || status === 7;

        if (status === 9 || inconsistente) {
            return (
                <Popover
                    trigger='click'
                    open={open_popover === cod}
                    onOpenChange={(open) => setOpen_popover(open ? cod : null)}
                    content={() => (
                        <DownloadReprocessarOS
                            arquivo_processado_url={arquivo_processado_url}
                            cod={cod}
                            cod_cliente={cod_cliente}
                            propriedade_nome={propriedade_nome}
                            talhao_nome={talhao_nome}
                            cod_calcario={cod_calcario}
                            cod_calcario_propriedade={cod_calcario_propriedade}
                            refetch={refetch_data_osColeta}
                            labelDownload={inconsistente ? 'Baixar resultado' : 'Baixar análise'}
                            // Produção: nos status 6/7 o reprocessar aparece só sem arquivo processado.
                            mostrarReprocessar={inconsistente ? arquivo_processado === '' : true}
                        />
                    )}
                >
                    {/* span nativo como gatilho: o Popover injeta o onClick (com evento)
                    nele; o ButtonCustom fica só visual (não engole o evento). */}
                    <Tooltip placement="bottom" title={inconsistente ? 'Enviar ou baixar' : 'Baixar análise ou Reprocessar OS'}>
                        <span style={{ display: 'inline-flex' }}>
                            <ButtonCustom
                                icon={<FontAwesomeIcon icon={inconsistente ? faArrowDownUpAcrossLine : faDownload} />}
                                type={inconsistente ? 'secondary' : 'primary'}
                                onClick={undefined}

                            />
                        </span>
                    </Tooltip>
                </Popover>
            );
        }

        // Sem calcário na propriedade o envio fica bloqueado (substitui o upload).
        if (cod_calcario_propriedade === null) {
            return (
                <Tooltip placement='top' trigger='hover' title='Informar calcário no cadastro da propriedade'>
                    <span style={{ display: 'inline-flex' }}>
                        <ButtonCustom
                            type='secondary'
                            onClick={undefined}
                            disabled
                            icon={<FontAwesomeIcon icon={faWarning} />}
                        />
                    </span>
                </Tooltip>
            );
        }

        return (
            <Upload
                accept='.csv,.txt'
                onChange={(file) =>
                    handleUploadResult(file, cod, setResultAnalise, setTextCSV, setAbrirPreviewFile)
                }
                customRequest={dumpRequest}
                showUploadList={false}
            >
                <Tooltip title={'Enviar resultado da análise'}><samp>
                    <ButtonCustom
                        type='secondary'
                        onClick={undefined}
                        icon={<FontAwesomeIcon icon={faUpload} />}
                        // Produção: habilitado somente em ENVIADO PARA ANÁLISE (4) e RESULTADO COM ERRO (8).
                        disabled={permissions?.alteracao === 0 || !(status === 4 || status === 8)}
                    // title='Enviar Resultado Análise'
                    />
                </samp></Tooltip>
            </Upload>
        );
    }

    // A tabela só some quando o servidor não tem nenhum registro. Durante o
    // carregamento de uma nova página ela continua montada, senão a paginação
    // desapareceria justamente no clique que a acionou.
    const sem_registros = !loading && total === 0;

    return (
        <Container>
            {sem_registros && (
                <Empty
                    style={{ marginTop: 100 }}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<>Nenhuma Ordem de serviço cadastrada</>}
                />
            )}

            <Render condition={!sem_registros}>
                <HeaderTable
                    itens={[
                        { valor: '', width: 40 },
                        { valor: 'Data coleta', width: 130 },
                        { valor: 'Data Liberada', width: 130 },
                        { valor: 'Talhão', width: 'calc(100% - 830px)' },
                        { valor: 'Status', width: 190 },
                        { valor: 'Ações', width: 340 },
                    ]}
                    style={{ flexShrink: 0 }}
                />

                <BodyTable
                    paginate={total}
                    paginateFilter={total_filtrado}
                    onChangeItensPage={setPagination}
                    onChangePage={setPage}
                    current_page={page}
                    setCurrent_page={setPage}
                    style={{ flex: 1, minHeight: 0 }}
                >
                    {/* Primeira carga: nada em tela ainda, spinner ocupa a tabela. */}
                    <Render condition={loading}>
                        <Carregando
                            animation
                            legenda="Carregando ordens de serviço..."
                            justifyContent="center"
                            height={400}
                        />
                    </Render>

                    {/* Troca de página/busca: linhas antigas seguem visíveis por baixo. */}
                    <Render condition={!loading && buscando}>
                        <div className="Solo__overlayBuscando">
                            <div className="Solo__overlayBuscando__fundo">
                                <Carregando
                                    animation
                                    legenda="Carregando ordens de serviço..."
                                    justifyContent="center"
                                    size="default"
                                />
                            </div>
                        </div>
                    </Render>

                    {!loading && (lista_os ?? []).map(({ cod, cod_calcario, cod_safra_conta, cod_calcario_propriedade, laboratorio_nome,
                        observacao, resultado_inconsistente, data_coleta, data_liberada, talhao_nome, status,
                        propriedade_nome, arquivo_processado_url, arquivo_processado, cod_cliente
                    }) => {
                        return (
                            <RowTable key={cod}>
                                <RowItem width={40}>
                                    <IconeAlerta
                                        cod_calcario={cod_calcario}
                                        cod_calcario_propriedade={cod_calcario_propriedade}
                                        cod_safra_conta={cod_safra_conta}
                                        laboratorio_nome={laboratorio_nome}
                                        observacao={observacao}
                                        resultado_inconsistente={resultado_inconsistente}
                                        status={status}
                                    />
                                </RowItem>
                                <RowItem fontSize={13} width={130}>
                                    {data_coleta === null ? '' : dayjs(data_coleta).format('DD/MM/YYYY')}
                                </RowItem>
                                <RowItem fontSize={13} width={130}>
                                    {data_liberada === null ? '' : dayjs(data_liberada).format('DD/MM/YYYY')}
                                </RowItem>
                                <RowItem fontSize={13} width={'calc(100% - 830px)'}>
                                    {talhao_nome}
                                </RowItem>
                                <RowItem width={190}>
                                    <Tag
                                        className='tag_os'
                                        color={statusBackground[status]}
                                        style={{
                                            color: statusColor[status],
                                            border: `1px solid ${statusBorder[status]}`,
                                        }}
                                        onClick={() => abrirModal(cod)}
                                    >
                                        <FontAwesomeIcon icon={statusIcones[status]} />
                                        {verificarStatusNome(status)}
                                    </Tag>
                                </RowItem>
                                <RowItem width={'340px'} gap={10}>
                                    <Tooltip title="Excluir OS" placement="bottom"><samp>
                                        <DeleteButton
                                            open={confirmar_exclusao && id_item_atual === cod}
                                            trigger={setConfirmar_exclusao}
                                            onTrigger={() => {
                                                setId_item_atual(cod)
                                                setNome_item_atual(propriedade_nome)
                                            }}
                                            loading={carregando_excluir_os}
                                            title="Tem certeza que deseja excluir essa OS?"
                                            message={
                                                <div
                                                    style={{
                                                        width: '323px',
                                                        display: 'flex',
                                                        padding: '8px',
                                                        backgroundColor: '#FFF0D9',
                                                    }}
                                                >
                                                    <h3 style={{ padding: '0px', margin: '0px', color: '#DF8600', lineHeight: '1.3', fontSize: '13px' }}>
                                                        {' '}
                                                        Atenção: Ao deletar essa OS comprometerá a sincronização no app caso
                                                        esteja ocorrendo a execução no campo.
                                                    </h3>
                                                </div>
                                            }
                                            deleteds={[propriedade_nome]}
                                            onDelete={() => {
                                                mutate_excluir_os({ cod_os: cod, refetch_data_osColeta })
                                            }}
                                            disabled={carregando_excluir_os || permissions?.exclusao === 0}
                                            typeButtonTrigger='tertiary'
                                        /></samp>
                                    </Tooltip>

                                    <Tooltip title="Visualizar pontos do talhão"><samp>
                                        <ButtonCustom
                                            icon={<FontAwesomeIcon icon={faMapLocationDot} />}
                                            type='secondary'
                                            onClick={() => { abrirVisualizarMapa(cod); }}
                                            disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                                        />
                                    </samp></Tooltip>


                                    <Tooltip title="Clonar O.S"><samp>
                                        <ButtonCustom
                                            icon={<FontAwesomeIcon icon={faCopy} />}
                                            type='secondary'
                                            onClick={() => { copiarOs(cod); }}
                                            hidden={permissions?.inclusao === 0}
                                        />
                                    </samp></Tooltip>

                                    {acaoArquivo({
                                        cod,
                                        status,
                                        arquivo_processado,
                                        arquivo_processado_url,
                                        cod_cliente,
                                        propriedade_nome,
                                        talhao_nome,
                                        cod_calcario,
                                        cod_calcario_propriedade,
                                    })}

                                    <ButtonCustom
                                        icon={<FontAwesomeIcon icon={faEye} />}
                                        onClick={() => {
                                            editarOs(cod)
                                        }}
                                        disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                                    >
                                        Ver / Editar
                                    </ButtonCustom>
                                </RowItem>
                            </RowTable>
                        )
                    })}

                    {/* Servidor tem registros, mas o filtro por talhão zerou esta página. */}
                    <Render condition={!loading && (lista_os ?? []).length === 0}>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<>Nenhuma OS encontrada nesta página</>}
                        />
                    </Render>
                </BodyTable>

                <VisualizarMapaTabela
                    open={abrirMapa}
                    update={cod_mapa}
                    setOpen={setAbrirMapa}
                />

                <StatusTimeLine
                    numero_pedido={numero_pedido}
                    abrirStatus={abrirStatus}
                    setAbrirStatus={setAbrirStatus}
                    status_selecionada={status_selecionada}
                    setStatus_selecionada={setStatus_selecionada}
                    setStatus_selecionada_id={setStatus_selecionada_id}
                    dataStatusOs={dataStatusOs}
                    alterarStatus={alterarStatus}
                    loading_status={loading_status}
                    fecharModal={fecharModal}
                />

                <CsvVisualizationModal
                    isOpen={abrirPreviewFile}
                    onClose={() => setAbrirPreviewFile(false)}
                    dataCSV={textCSV}
                />
            </Render>

            {/* Gaveta de cadastro/edição/cópia — sempre montada para permitir abrir
                mesmo com a lista vazia (via botão "Novo" do módulo pai). */}
            <FormularioOsColeta
                abrirGaveta={abrirGaveta}
                fecharGaveta={fecharGaveta}
                refetchLista={refetch_data_osColeta}
                update={update}
                copiar={copiar}
            />
        </Container>
    )
});

Solo.displayName = 'Solo';